export default {
  brand: "Clefs de Lys SA",
  hero: {
    subtitle: "Clés, Cylindres & Dépannage",
    tagline: "Clefs, serrurerie, dépannages... Notre domaine depuis plus de 25 ans !",
    cta: "Nous Contacter",
    operatingSince: "En activité depuis 2001",
  },
  nav: {
    home: "Accueil",
    blog: "Blog",
    partners: "Partenaires",
    contact: "Contact",
  },
  services: {
    badge: "Nos Services",
    heading: "Ce Que Nous Offrons",
    description: "Des solutions complètes de serrurerie et de sécurité adaptées à vos besoins",
    items: {
      keyCutting: {
        title: "Taille de Clés de Précision",
        description: "Duplication de clés haute précision avec des machines à la pointe de la technologie pour toutes les grandes marques et profils personnalisés.",
      },
      cylinders: {
        title: "Systèmes de Cylindres",
        description: "Cylindres de serrure haut de gamme et systèmes de sécurité complets pour applications résidentielles, commerciales et industrielles.",
      },
      masterKey: {
        title: "Solutions Passe-Partout",
        description: "Hiérarchies de passe-partout sur mesure conçues pour les gestionnaires immobiliers, les hôtels et les grandes installations.",
      },
      repair: {
        title: "Réparation & Installation",
        description: "Services professionnels de réparation, remplacement et installation de serrures avec des délais d'intervention rapides.",
      },
    },
  },
  about: {
    label: "À Propos de Clefs de Lys SA",
    text: "Fondée en 2001 au cœur de la Suisse, Clefs de Lys SA est passée d'un petit atelier de serrurerie à un nom de confiance dans la taille de clés et les systèmes de cylindres de sécurité. Nous combinons l'artisanat traditionnel avec la technologie moderne de précision pour servir des milliers de clients résidentiels et commerciaux dans toute la région.",
    stats: {
      experience: "Années d'Expérience",
      keys: "Clés Taillées par An",
      satisfaction: "Satisfaction Client",
      partners: "Partenaires Commerciaux",
    },
  },
  trust: {
    label: "En Chiffres",
    heading: "La Précision en Chiffres",
    text: "Plus d'un quart de siècle d'artisanat suisse, livré clé par clé. Voici ce que cela donne en chiffres.",
    counters: {
      keys: {
        value: "250K+",
        label: "Clés Taillées",
      },
      cylinders: {
        value: "85K+",
        label: "Cylindres Installés",
      },
      clients: {
        value: "12K+",
        label: "Clients Satisfaits",
      },
      projects: {
        value: "3,2K+",
        label: "Projets Sécurité",
      },
      response: {
        value: "<24h",
        label: "Temps de Réponse",
      },
    },
  },
  partners: {
    badge: "Réseau de Confiance",
    heading: "Nos Fournisseurs & Partenaires",
    description: "Nous travaillons avec les fabricants et distributeurs les plus respectés de Suisse pour vous offrir les meilleurs produits",
    keyPartners: "Partenaires Clés & Cylindres",
    allPartners: "Fournisseurs",
    realEstate: "Partenaires Immobiliers",
    realEstateDescription: "Agences immobilières et régies de confiance avec lesquelles nous collaborons avec fierté",
    viewAll: "Voir Tout",
    pageHeading: "Tous Nos Partenaires",
    pageDescription: "Découvrez l'ensemble de notre réseau de partenaires, fournisseurs et collaborateurs de confiance en Suisse et au-delà.",
  },
  blog: {
    badge: "Derniers Articles",
    heading: "Perspectives & Expertise",
    description: "Conseils, guides et actualités du secteur de la part des spécialistes suisses des clés et cylindres de confiance.",
    readMore: "Lire la suite",
    backToAll: "Retour à tous les articles",
    backToBlog: "Retour au Blog",
    notFoundTitle: "Article Introuvable",
    notFoundText: "L'article que vous recherchez n'existe pas ou a peut-être été déplacé.",
    relatedTitle: "Articles Similaires",
    helpfulTitle: "Cet article vous a-t-il été utile ?",
    helpfulText: "Partagez-le avec votre équipe ou vos collègues.",
    shareX: "Partager sur X",
    shareLinkedIn: "Partager sur LinkedIn",
    copyLink: "Copier le lien",
  },
  cta: {
    heading: "Prêt à sécuriser ce qui compte?",
    description: "Que vous ayez besoin d'un double de clé ou d'un système complet de passe-partout pour votre bâtiment, notre équipe est là pour vous aider.",
    button: "Contactez-Nous",
    addressLabel: "Nous Trouver",
    phoneLabel: "Appelez-Nous",
    emailLabel: "Écrivez-Nous",
  },
  footer: {
    heading: "Restez Informé",
    description: "Abonnez-vous à notre newsletter pour des conseils de sécurité et des actualités.",
    placeholder: "Votre adresse email",
    subscribe: "S'abonner",
    success: "Merci de votre abonnement!",
    error: "Une erreur est survenue. Veuillez réessayer.",
    navigation: "Navigation",
    contact: "Contact",
    address: "Adresse",
    addressLines: "Rue Alexandre Cailler 6, 1636 Broc, Suisse",
    privacy: "Politique de Confidentialité",
    legal: "Mentions Légales / Impressum",
    terms: "Conditions Générales",
    rights: "Tous droits réservés.",
  },
  contact: {
    badge: "Nous Contacter",
    heading: "Contactez-Nous",
    description: "Que vous ayez besoin d'une clé taillée, d'un cylindre remplacé ou de conseils pour sécuriser votre propriété — nous sommes là pour vous aider.",
    formTitle: "Envoyez-nous un message",
    name: "Nom",
    namePlaceholder: "Votre nom",
    email: "Email",
    emailPlaceholder: "votre@email.com",
    phone: "Téléphone",
    phonePlaceholder: "+41 XX XXX XX XX",
    message: "Message",
    messagePlaceholder: "Comment pouvons-nous vous aider ?",
    photo: "Photos (optionnel)",
    photoHint: "Joignez des photos de votre serrure, clé ou porte — JPG, PNG, WebP et plus acceptés",
    send: "Envoyer le Message",
    success: "Message envoyé avec succès !",
    errorGeneric: "Une erreur est survenue. Veuillez réessayer.",
    errorNetwork: "Erreur réseau. Veuillez vérifier votre connexion et réessayer.",
    infoTitle: "Informations de Contact",
    addressLabel: "Adresse",
    phoneLabel: "Téléphone",
    emailLabel: "Email",
    hoursLabel: "Horaire magasin",
    getDirections: "Itinéraire",
    days: {
      monday: "Lundi",
      tuesday: "Mardi",
      wednesday: "Mercredi",
      thursday: "Jeudi",
      friday: "Vendredi",
    },
    closed: "Fermé",
    hoursSlot: "07h30 – 12h00 / 13h30 – 17h00",
    holidaysNote: "Pour le service de clés, le magasin est fermé les jours fériés, chômés et les ponts.",
  },
  presentation: {
    heading: "Clefs de Lys SA vous offre plusieurs prestations dans les domaines suivants :",
    items: [
      "Dépannage serrures, cylindres, clefs, coffre-fort, etc.",
      "Pose ferme-porte, arrêt de porte, réglages, remplacement",
      "Pose systèmes anti-effractions",
      "Pose serrures électroniques, gâches électriques, etc.",
      "Cylindres électriques",
      "Vente et pose coffre-fort",
      "Création de plans de fermetures",
      "Service de clefs",
      "Petite serrurerie",
    ],
  },
  language: "Langue",
  privacyPolicy: {
    title: "Politique de Confidentialité",
    lastUpdated: "Dernière mise à jour : 22.07.2026",
    sections: [
      {
        heading: "1. Responsable du Traitement",
        body: "L'entité responsable du traitement des données personnelles conformément à la législation suisse sur la protection des données est :\n\nClefs de Lys SA\nRue Alexandre Cailler 6\n1636 Broc\nSuisse\n\nEmail : service@clefsdelys.ch\nTéléphone : +41 26 919 53 60",
      },
      {
        heading: "2. Informations Générales",
        body: "La protection de vos données personnelles est importante pour Clefs de Lys SA. Nous traitons les données personnelles conformément à la Loi fédérale sur la protection des données (LPD) et aux autres dispositions légales applicables.\n\nLa présente Politique de Confidentialité explique quelles données personnelles nous collectons, comment nous les utilisons et quels sont vos droits concernant vos informations personnelles.",
      },
      {
        heading: "3. Données Personnelles Collectées",
        body: "Dans le cadre de nos activités commerciales, nous pouvons collecter et traiter les données personnelles suivantes :\n\n• Nom et prénom ;\n• Adresse postale ;\n• Adresse électronique ;\n• Numéro de téléphone ;\n• Informations relatives aux demandes, devis et commandes ;\n• Informations relatives à nos services (clés, cylindres, systèmes de fermeture, systèmes de passe-partout, plans de fermeture et services de serrurerie) ;\n• Informations nécessaires à la facturation et aux besoins administratifs.",
      },
      {
        heading: "4. Finalités du Traitement",
        body: "Clefs de Lys SA traite les données personnelles uniquement à des fins commerciales légitimes, notamment :\n\n• Le traitement des demandes et commandes des clients ;\n• L'établissement de devis et d'offres ;\n• La fourniture de services de serrurerie et de sécurité ;\n• La gestion des relations clients ;\n• L'établissement des factures et le respect des obligations comptables ;\n• La communication avec les clients concernant nos services.",
      },
      {
        heading: "5. Base Légale du Traitement",
        body: "Le traitement des données personnelles repose sur :\n\n• L'exécution d'obligations contractuelles ou de mesures précontractuelles ;\n• Le respect d'obligations légales ;\n• Notre intérêt légitime à fournir des services sécurisés et fiables.",
      },
      {
        heading: "6. Communication des Données à des Tiers",
        body: "Clefs de Lys SA ne vend, ne loue ni n'échange de données personnelles.\n\nLes données personnelles ne peuvent être partagées avec des tiers que lorsque cela est nécessaire, notamment avec :\n\n• Les fournisseurs ou partenaires impliqués dans l'exécution des commandes des clients ;\n• Les prestataires de services techniques nécessaires au fonctionnement de nos systèmes informatiques et de notre site internet ;\n• Les autorités publiques lorsque la loi l'exige.\n\nTous les tiers concernés sont tenus de respecter la confidentialité et la sécurité des données personnelles.",
      },
      {
        heading: "7. Confidentialité des Informations de Sécurité",
        body: "En raison de la nature de nos activités, Clefs de Lys SA peut traiter des informations confidentielles liées à la sécurité, notamment :\n\n• Les informations relatives aux systèmes de passe-partout ;\n• Les plans de fermeture ;\n• Les configurations de cylindres ;\n• Les informations de contrôle d'accès.\n\nCes informations sont traitées de manière confidentielle et uniquement à des fins autorisées et pour des clients légitimes.",
      },
      {
        heading: "8. Conservation des Données",
        body: "Clefs de Lys SA conserve les données personnelles uniquement aussi longtemps que nécessaire pour atteindre les finalités pour lesquelles elles ont été collectées.\n\nLes informations commerciales et comptables sont conservées conformément aux délais légaux de conservation applicables en Suisse.",
      },
      {
        heading: "9. Sécurité des Données",
        body: "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger les données personnelles contre :\n\n• L'accès non autorisé ;\n• La perte ou la destruction ;\n• La modification non autorisée ;\n• La divulgation à des personnes non autorisées.",
      },
      {
        heading: "10. Cookies et Technologies du Site Internet",
        body: "Notre site internet peut utiliser des cookies et des technologies similaires pour assurer le bon fonctionnement du site et améliorer l'expérience utilisateur.\n\nLes cookies peuvent être utilisés pour :\n\n• Le fonctionnement technique du site internet ;\n• La mémorisation des préférences de l'utilisateur ;\n• L'analyse des performances du site internet (uniquement si des outils d'analyse sont mis en œuvre).\n\nVous pouvez gérer ou désactiver les cookies via les paramètres de votre navigateur.",
      },
      {
        heading: "11. Liens Externes",
        body: "Notre site internet peut contenir des liens vers des sites internet externes.\n\nClefs de Lys SA n'est pas responsable des pratiques de confidentialité ni du contenu des sites internet tiers. Nous vous recommandons de consulter séparément les politiques de confidentialité de ces sites.",
      },
      {
        heading: "12. Vos Droits",
        body: "En vertu des lois applicables en matière de protection des données, vous pouvez avoir le droit de :\n\n• Demander des informations sur vos données personnelles ;\n• Demander la rectification de données inexactes ;\n• Demander la suppression de vos données personnelles lorsque la loi le permet ;\n• Vous opposer à certaines activités de traitement.\n\nPour exercer vos droits, veuillez nous contacter en utilisant les coordonnées indiquées ci-dessus.",
      },
      {
        heading: "13. Modifications de la Politique de Confidentialité",
        body: "Clefs de Lys SA se réserve le droit de modifier la présente Politique de Confidentialité lorsque cela est nécessaire en raison de changements légaux, techniques ou organisationnels.\n\nLa dernière version publiée sur notre site internet fait foi.",
      },
    ],
  },
  legalNotice: {
    title: "Mentions Légales / Impressum",
    lastUpdated: "Dernière mise à jour : 22.07.2026",
    sections: [
      {
        heading: "Informations sur la Société",
        body: "Clefs de Lys SA\nRue Alexandre-Cailler 6\n1636 Broc\nSuisse\n\nForme juridique : Société Anonyme (SA)\n\nNuméro IDE / CHE : CHE-109.270.807\n\nNuméro du Registre du Commerce : CH-217.0.431.678-4\n\nOffice du Registre du Commerce : Canton de Fribourg, Suisse",
      },
      {
        heading: "Coordonnées",
        body: "Téléphone : +41 26 919 53 60\nEmail : service@clefsdelys.ch\nSite internet : www.Clefsdelys.ch",
      },
      {
        heading: "Responsable du Contenu du Site",
        body: "L'entreprise responsable du contenu publié sur ce site internet est :\n\nClefs de Lys SA\nRue Alexandre-Cailler 6\n1636 Broc\nSuisse",
      },
      {
        heading: "Objet du Site Internet",
        body: "Ce site internet fournit des informations sur Clefs de Lys SA et ses services, y compris les services de serrurerie, les services de clés, les cylindres, les systèmes de fermeture, les systèmes de passe-partout, les solutions de sécurité et les services professionnels associés.",
      },
      {
        heading: "Propriété Intellectuelle",
        body: "Tout le contenu publié sur ce site internet, y compris les textes, images, logos, graphiques, documents et autres matériels, est protégé par les lois applicables en matière de propriété intellectuelle.\n\nToute reproduction, distribution, modification ou utilisation du contenu du site internet sans autorisation écrite préalable de Clefs de Lys SA est interdite.",
      },
      {
        heading: "Clause de Non-Responsabilité",
        body: "Clefs de Lys SA met tout en œuvre pour garantir que les informations fournies sur ce site internet sont exactes, complètes et à jour.\n\nCependant, Clefs de Lys SA ne peut garantir que les informations publiées sur ce site internet sont toujours exemptes d'erreurs ou d'omissions.\n\nClefs de Lys SA décline toute responsabilité pour les dommages directs ou indirects résultant de l'utilisation de ce site internet ou des informations qui y sont fournies.",
      },
      {
        heading: "Liens Externes",
        body: "Ce site internet peut contenir des liens vers des sites internet externes exploités par des tiers.\n\nClefs de Lys SA n'a aucun contrôle sur le contenu, la disponibilité ou les pratiques de confidentialité de ces sites internet externes et n'assume aucune responsabilité à leur égard.",
      },
      {
        heading: "Protection des Données",
        body: "Le traitement des données personnelles collectées via ce site internet est régi par notre Politique de Confidentialité.\n\nPour plus d'informations concernant la collecte, l'utilisation et la protection des données personnelles, veuillez consulter notre Politique de Confidentialité.",
      },
      {
        heading: "Droit Applicable et Juridiction",
        body: "Les présentes Mentions Légales sont régies par le droit suisse.\n\nTout litige découlant de l'utilisation de ce site internet est soumis aux tribunaux compétents en Suisse, sauf disposition légale impérative contraire.",
      },
    ],
  },
  termsOfService: {
    title: "Conditions Générales",
    lastUpdated: "Date d'entrée en vigueur : 22 juillet 2026",
    intro: "Bienvenue sur le site internet de Clefs de Lys SA. Les présentes Conditions Générales (les « Conditions ») régissent votre accès et votre utilisation de notre site internet, de nos produits et de nos services. En accédant à ce site internet ou en faisant appel à nos services, vous acceptez de vous conformer aux présentes Conditions. Si vous n'êtes pas d'accord, veuillez cesser d'utiliser le site internet.",
    sections: [
      {
        heading: "1. À Propos de Clefs de Lys SA",
        body: "Clefs de Lys SA est une entreprise suisse de serrurerie et de sécurité fournissant des solutions professionnelles pour les clients résidentiels, commerciaux et industriels. Nos services incluent la duplication de clés, les cylindres de sécurité, les systèmes de passe-partout, les solutions de contrôle d'accès, la quincaillerie de porte, l'installation de coffres-forts, les réparations de serrures, l'assistance serrurerie d'urgence et les services de sécurité associés.",
      },
      {
        heading: "2. Acceptation des Présentes Conditions",
        body: "En utilisant ce site internet, en demandant un devis, en passant une commande ou en utilisant nos services, vous reconnaissez avoir lu, compris et accepté les présentes Conditions Générales.",
      },
      {
        heading: "3. Utilisation du Site Internet",
        body: "Vous acceptez d'utiliser ce site internet de manière responsable et uniquement à des fins licites.\n\nVous ne pouvez pas :\n\n• interférer avec le fonctionnement ou la sécurité du site internet ;\n• tenter d'accéder sans autorisation à nos systèmes ;\n• télécharger des logiciels malveillants ou du contenu nuisible ;\n• utiliser abusivement les formulaires de contact ou les canaux de communication ;\n• reproduire ou distribuer le contenu du site internet sans autorisation écrite préalable.",
      },
      {
        heading: "4. Informations sur le Site Internet",
        body: "Nous faisons des efforts raisonnables pour garantir que toutes les informations publiées sur ce site internet sont exactes et à jour.\n\nCependant, les descriptions de produits, les spécifications, la disponibilité, les images et les prix sont fournis à titre d'information générale uniquement et peuvent être mis à jour ou corrigés sans préavis.",
      },
      {
        heading: "5. Produits et Services",
        body: "Nos produits et services peuvent inclure :\n\n• Taille et duplication de clés\n• Cylindres de sécurité\n• Systèmes de fermeture mécaniques et électroniques\n• Systèmes de passe-partout\n• Solutions de contrôle d'accès\n• Coffres-forts et produits de stockage sécurisé\n• Quincaillerie de porte\n• Installation et réparation de serrures\n• Services de serrurerie d'urgence\n• Maintenance et mises à niveau de sécurité\n\nLa disponibilité peut varier en fonction des stocks, des fournisseurs ou des exigences techniques.",
      },
      {
        heading: "6. Devis et Commandes",
        body: "Tous les devis sont fournis sans engagement, sauf indication contraire expresse.\n\nUne commande ne devient contraignante qu'après confirmation par Clefs de Lys SA.\n\nPour certains produits de sécurité, les clients peuvent être tenus de fournir une preuve de propriété, une vérification d'identité, des cartes d'autorisation ou des documents supplémentaires avant la fabrication ou la livraison.\n\nNous nous réservons le droit de refuser ou d'annuler les commandes qui ne peuvent pas être vérifiées ou qui ne sont pas conformes aux exigences légales ou de sécurité.",
      },
      {
        heading: "7. Prix et Paiement",
        body: "Les prix peuvent changer sans préavis jusqu'à ce qu'une commande ait été confirmée.\n\nLes factures doivent être payées dans le délai de paiement indiqué sur la facture.\n\nLes retards de paiement peuvent entraîner des frais de rappel, des intérêts légaux, la suspension des services ou des procédures de recouvrement légal lorsque la loi suisse le permet.",
      },
      {
        heading: "8. Livraison et Installation",
        body: "Les dates de livraison sont des estimations, sauf confirmation écrite spécifique.\n\nClefs de Lys SA n'est pas responsable des retards causés par les fournisseurs, les fabricants, les entreprises de transport, les procédures douanières, les cas de force majeure ou les circonstances échappant à notre contrôle raisonnable.\n\nLes clients sont responsables de garantir un accès sécurisé aux sites d'installation.\n\nDes travaux supplémentaires demandés pendant l'installation peuvent entraîner des frais supplémentaires après approbation du client.",
      },
      {
        heading: "9. Services d'Urgence",
        body: "Les services de serrurerie d'urgence sont proposés en fonction de la disponibilité des techniciens.\n\nLes délais d'intervention ne peuvent pas être garantis et dépendent de la charge de travail, de la distance, des conditions météorologiques, du trafic et des circonstances opérationnelles.\n\nDes frais supplémentaires peuvent s'appliquer en dehors des heures normales de bureau.",
      },
      {
        heading: "10. Responsabilités du Client",
        body: "Les clients sont responsables de fournir des informations exactes et complètes lorsqu'ils demandent des produits ou des services.\n\nCela inclut, le cas échéant :\n\n• les références des serrures ;\n• les dimensions des cylindres ;\n• les numéros de clés ;\n• les documents d'autorisation de sécurité ;\n• les détails d'installation ;\n• les informations de propriété.\n\nDes informations incorrectes peuvent entraîner des retards, des coûts supplémentaires ou des produits incompatibles.",
      },
      {
        heading: "11. Garantie",
        body: "Le cas échéant, les produits sont couverts par la garantie du fabricant.\n\nLes travaux d'installation et de réparation effectués par Clefs de Lys SA sont couverts contre les défauts de fabrication conformément au droit suisse applicable ou à toute garantie écrite fournie.\n\nLa garantie ne couvre pas les dommages résultant d'une mauvaise utilisation, de modifications non autorisées, d'accidents, de l'usure normale, d'un entretien inapproprié ou d'une intervention de tiers.",
      },
      {
        heading: "12. Limitation de Responsabilité",
        body: "Dans toute la mesure permise par la loi applicable, Clefs de Lys SA ne pourra être tenue responsable des dommages indirects, accessoires, consécutifs ou économiques découlant de l'utilisation de ce site internet, des produits ou des services.\n\nRien dans les présentes Conditions ne limite la responsabilité lorsque cette limitation est interdite par le droit suisse impératif.",
      },
      {
        heading: "13. Propriété Intellectuelle",
        body: "Tout le contenu disponible sur ce site internet — y compris les textes, graphiques, logos, icônes, images, documents, mises en page et logiciels — est la propriété de Clefs de Lys SA ou de ses concédants de licence et est protégé par les lois sur la propriété intellectuelle.\n\nAucun contenu ne peut être copié, reproduit, distribué ou modifié sans autorisation écrite préalable.",
      },
      {
        heading: "14. Protection des Données",
        body: "Votre utilisation de ce site internet est également régie par notre Politique de Confidentialité.\n\nLes informations personnelles ne sont traitées qu'à des fins commerciales légitimes et conformément à la législation suisse applicable en matière de protection des données.",
      },
      {
        heading: "15. Sites Internet de Tiers",
        body: "Ce site internet peut contenir des liens vers des sites internet externes pour votre commodité.\n\nClefs de Lys SA n'est pas responsable de la disponibilité, du contenu, de la sécurité ou des pratiques de confidentialité des sites internet de tiers.",
      },
      {
        heading: "16. Disponibilité du Service",
        body: "Nous nous efforçons de maintenir un accès continu à notre site internet et à nos services en ligne.\n\nCependant, nous ne garantissons pas une disponibilité ininterrompue et nous réservons le droit de suspendre ou de modifier les services pour des raisons de maintenance, de mises à jour de sécurité, d'améliorations techniques ou de circonstances imprévues.",
      },
      {
        heading: "17. Force Majeure",
        body: "Clefs de Lys SA ne pourra être tenue responsable des retards ou de l'inexécution de ses obligations résultant d'événements échappant à son contrôle raisonnable, y compris les catastrophes naturelles, les grèves, les perturbations des fournisseurs, les cyber-incidents, les mesures gouvernementales ou d'autres cas de force majeure.",
      },
      {
        heading: "18. Modifications des Présentes Conditions",
        body: "Nous pouvons mettre à jour les présentes Conditions Générales de temps à autre.\n\nLa dernière version sera toujours publiée sur ce site internet avec la date d'entrée en vigueur mise à jour.\n\nL'utilisation continue du site internet après publication constitue l'acceptation des Conditions révisées.",
      },
      {
        heading: "19. Droit Applicable",
        body: "Les présentes Conditions Générales sont régies par le droit suisse.\n\nTout litige découlant des présentes Conditions ou de l'utilisation de nos services est soumis à la compétence des tribunaux compétents du Canton de Fribourg, sauf disposition légale impérative contraire.",
      },
      {
        heading: "20. Contact",
        body: "Si vous avez des questions concernant les présentes Conditions Générales ou l'un de nos services, veuillez contacter Clefs de Lys SA en utilisant les coordonnées disponibles sur ce site internet.",
      },
    ],
  },
};